import { render, staticRenderFns } from "./createClass.vue?vue&type=template&id=0bad6423&"
import script from "./createClass.vue?vue&type=script&lang=js&"
export * from "./createClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports